import Prefixer from 'inline-style-prefixer';
import fonts from '../../../fonts';

const dialogStyle = new Prefixer().prefix({
  wrapper: {
    padding: '24px',
    paddingTop: '22px',
  },
  to: {
    ...fonts.regular,
    color: 'black',
    fontSize: 16,
    width: 30,
    float: 'left',
    paddingTop: 2,
  },
  autocompleteWrapper: {
    marginLeft: 30,
  },
  groupNameField: {
    width: 'calc(100% - 30px)',
    marginLeft: 30,
    fontSize: 16,
  },
});

export default dialogStyle;
